/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getPlayersAmount, getVolumePotencial } from "../utils/getOptionsFromSearchs";
import { makeDatasetForClientShareCharts, makeDatasetForSellOutLegenda } from "../utils/makeDatasetForCharts";

const PriceSearchChartsLegend = ({ items, itemsOthers, title, tipo }) => {
  const [data, setData] = useState();
  const [legends, setLegends] = useState([]);
  useEffect(() => {
    switch (tipo) {
      case "linha": {
        const amount = getPlayersAmount(items.organizedItems).length;
        setData(amount + ` player${amount == 1 ? "" : "s"}`);
        setLegends(makeDatasetForSellOutLegenda(items.organizedItems));
        break;
      }
      case "barra": {
        setData(getVolumePotencial(items.organizedItems) + ` t/mês`);
        setLegends(makeDatasetForClientShareCharts(items.organizedItems, "legenda"));
        break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.organizedItems]);
  return (
    <div className="px-8 charts-legend-container">
      <div className="mt-8">
        {legends.map((legend) => (
          <div key={`${legend[0]}-${legend[1]}`} className="flex items-center gap-4 first:mt-0 mt-3 uppercase">
            <span
              className="w-5 h-5 rounded-full"
              style={{ backgroundColor: legend[1], maxWidth: "20px", minWidth: "20px", height: "20px" }}
            />
            <p className="text-primaria font-bold">{legend[0]}</p>
          </div>
        ))}
      </div>
      <div className="chart-legend flex flex-col md:flex-row w-full items-center justify-between gap-2 bg-[#F2F2F2] p-2 rounded-md mt-8 pl-5">
        <p className="text-primaria text-xl font-bold">{title}</p>
        <span className="bg-primaria rounded-md w-full md:w-auto text-center">
          <p className="text-white text-xl font-bold py-2 px-4">{data?.replace(/\./g, ",")}</p>
        </span>
      </div>
    </div>
  );
};

PriceSearchChartsLegend.propTypes = {
  items: PropTypes.shape({
    organizedItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nome: PropTypes.string,
        cor: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  itemsOthers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string,
      cor: PropTypes.string,
    })
  ),
  title: PropTypes.string.isRequired,
  tipo: PropTypes.oneOf(["linha", "barra"]).isRequired,
};

PriceSearchChartsLegend.defaultProps = {
  itemsOthers: [],
};

export default PriceSearchChartsLegend;
